const state = {
    ids: [1,2,3],
    all: [
        {
            id: 1, name: 'Pending'
        },
        {
            id: 2, name: 'In Process'
        },
        {
            id: 3, name: 'Processed'
        }
    ],
    current_page: 1,
    per_page: 3,
    from: 1,
    to: 3,
    last_page: null,
    total: null,
};

// getters
const getters = {
    all: (state, getters, rootState) => {
        return state.all;
    },
    ids: (state, getters, rootState) => {
        return state.ids;
    }
};

// actions
const actions = {
};

// mutations
const mutations = {
    setStatus (state, result) {
        state.all = result.data;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/claimStatuses.js